import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class SoldQtyService extends BaseApiTemplateService<any> {
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.REPORTS_PREFIX + 'sales/total-sold-items-qty/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.REPORTS_PREFIX + 'sales/total-sold-items-qty/backoffice-ep';
    this.httpClient = http;
  }

  getSoldQty(dtoObject: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(this.apiUrl, dtoObject, this.getHttpHeader(apiVisa));
  }

  getSoldQtyPromise(dtoObject: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(this.apiUrl, dtoObject, this.getHttpHeader(apiVisa)).toPromise();
  }
}
